<template>
  <div>
    <div class="install-control">
      <button @click="send" class="btn btn-success">
        {{ "next_step" | setText("Далее") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  components: {},
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  async created() {},
  methods: {
    send() {
      let data = {
        app_id: this.transaction.exchange_id
          ? this.transaction.exchange_id
          : this.value.data.app_id,
      };

      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}client/open`,
        method: "POST",
        data: data,
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then((response) => {
          if (response.data) {
            this.$emit("setStep", "application-add-card");
            this.$emit("input", response.data);

            this.createTransaction({
              step: "application-add-card",
            });
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 500);
        });
    },
  },
  data() {
    return {};
  },
};
</script>

